import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { TState } from 'redux/config/root-types'
import { Actions_CurrentUser } from 'redux/modules/currentUser/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { I18nModal } from 'utils/i18n/i18nModal'

export const useUserDiscountDelete = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.userDiscountDelete)

  const discountId = useSelector(({ modals }: TState) => modals.data.id)

  const onSubmit = () => {
    dispatch(Actions_CurrentUser.saga.removeUserDiscount({ id: Number(discountId) }))
    dispatch(Actions_Modals.store.hideModal())
  }

  const onCancel = () => dispatch(Actions_Modals.store.hideModal())

  return { t, onSubmit, onCancel }
}
